import { isMobile } from './functions'

document.addEventListener('DOMContentLoaded', function (e) {
  const footer = e.target.querySelector('footer')
  if (footer) {
    function setActiveFooterCTA() {
      if (!isMobile()) {
        window.addEventListener('scroll', () => {
          if (
            window.innerHeight + window.scrollY >=
            e.target.body.scrollHeight
          ) {
            footer.querySelector('.middle__cta').classList.add('active')
          }
        })
      } else {
        footer.querySelector('.middle__cta').classList.add('active')
      }
    }

    window.addEventListener('load', setActiveFooterCTA)
    window.addEventListener('resize', setActiveFooterCTA)
  }
})
